import { lazy, Suspense } from 'react';
import { useAuth } from 'react-oidc-context';
import { Route, Routes } from 'react-router-dom';
import Loader from '../components/loader/Loader';
import NotFound from '../pages/NotFound';
import PrivateRoute from './PrivateRoute';

// Lazy load components for better performance
const Login = lazy(() => import('../pages/Login'));
const Spreadsheet = lazy(() => import('../pages/Spreadsheet'));

const RoutesPage = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes - accessible only when not authenticated */}
        {!auth.isAuthenticated && (
          <>
            <Route path="/" index element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </>
        )}

        {/* Protected Routes - accessible only when authenticated */}
        <Route element={<PrivateRoute />}>
          {/* Main application route */}
          <Route path="/" element={<Spreadsheet />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default RoutesPage;
